import {AppElement, html} from '../AppElement.js';

export default class PageRateManagement extends AppElement {
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('message', infinito.vao.messaging.handler);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('message', infinito.vao.messaging.handler);
    }

    updated(...args) {
        super.updated(...args);
        window.addEventListener('message', infinito.vao.messaging.handler);
    }

    render() {
        const authToken = localStorage.getItem('token');
        const hotel = window.infinito.vao.controller.storageHelper.getSelectedHotel();
        const recordDate = window.infinito.vao.controller.storageHelper.getCurrentDate();
        return html`
            <div style="height: 100%">
                <iframe
                  src="https://web.infinito.solutions/app/rate-management/rate-workbench?embed=true&authToken=${authToken}&hotelId=${hotel.id}&recordDate=${recordDate}"
                  frameBorder="0" style="width: 100%; height: 100%;"></iframe>
            </div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.PageRateManagement = PageRateManagement;
customElements.define('vao-page-rate-management', PageRateManagement);
